import React from 'react';

const facebookPage = 'https://www.facebook.com/WSW.IST';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=500&height=620&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const WorldSpaceWeekSocialFeed = () => (
  <section className="world-space-week-social" aria-labelledby="world-space-week-social-title">
    <div className="world-space-week-social-inner">
      <header className="world-space-week-social-header">
        <p className="section-eyebrow">STAY CONNECTED</p>
        <h2 id="world-space-week-social-title">Social Feed</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <div className="world-space-week-facebook-wrap">
        <iframe
          title="World Space Week at IST Facebook feed"
          src={facebookEmbed}
          width="500"
          height="620"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>

      <a
        className="world-space-week-facebook-link"
        href={facebookPage}
        target="_blank"
        rel="noopener noreferrer"
      >
        View World Space Week IST on Facebook <span aria-hidden="true">→</span>
      </a>
    </div>
  </section>
);

export default WorldSpaceWeekSocialFeed;
